package top.wcpe.allincore.ui.web.asset

internal enum class PreviewReadKind {
    ROOT_SOURCE,
    ROOT_BYTES,
    SOURCE_IMPORT,
    THEME,
    MOCK,
    MODEL,
    TEXTURE,
    BACKGROUND,
}

internal data class PreviewReadAsset(
    val canonicalPath: String,
    val kind: PreviewReadKind,
    val contentVersion: String,
    val actualBytes: Long,
)

internal data class AuthoritativeSourceAsset(
    val canonicalPath: String,
    val kind: PreviewReadKind,
    val contentVersion: String,
    val actualBytes: Long,
    val content: String,
)

internal data class AuthoritativeDependencyEdge(
    val referrerCanonicalPath: String,
    val dependencyCanonicalPath: String,
    val kind: PreviewReadKind,
)

internal class AuthoritativeReadSet(
    val root: AuthoritativeSourceAsset,
    dependencies: List<AuthoritativeSourceAsset>,
    edges: List<AuthoritativeDependencyEdge>,
) {
    private val dependencyValues = dependencies.toList()
    private val edgeValues = edges.toList()

    val dependencies: List<AuthoritativeSourceAsset>
        get() = dependencyValues.toList()

    val edges: List<AuthoritativeDependencyEdge>
        get() = edgeValues.toList()
}

internal fun AssetReferenceKind.toPreviewReadKind(): PreviewReadKind = when (this) {
    AssetReferenceKind.SOURCE_IMPORT -> PreviewReadKind.SOURCE_IMPORT
    AssetReferenceKind.THEME -> PreviewReadKind.THEME
    AssetReferenceKind.MOCK -> PreviewReadKind.MOCK
    AssetReferenceKind.MODEL -> PreviewReadKind.MODEL
    AssetReferenceKind.TEXTURE -> PreviewReadKind.TEXTURE
    AssetReferenceKind.BACKGROUND -> PreviewReadKind.BACKGROUND
}
